var map = {
	"./AlarmSVG.vue": "c68e",
	"./AlertSVG.vue": "25a4",
	"./ArrowSVG.vue": "b013",
	"./BadgeSVG.vue": "afca",
	"./CapSVG.vue": "2529",
	"./CertificateSVG.vue": "3305",
	"./CheckCircleSVG.vue": "9966",
	"./CheckSVG.vue": "51cb",
	"./CloseSVG.vue": "d3cc",
	"./FlashSVG.vue": "9532",
	"./HamburgueMenuSVG.vue": "cd65",
	"./HelpSVG.vue": "1f4d",
	"./HomeSVG.vue": "0d7e",
	"./HotSVG.vue": "a318",
	"./IdeaSVG.vue": "c3d7",
	"./InstagramSVG.vue": "a68a",
	"./LogoSVG.vue": "7ca2",
	"./MedalSVG.vue": "d177",
	"./PlaneSVG.vue": "3ef3",
	"./QuestionSVG.vue": "78d9",
	"./SearchSVG.vue": "c86c",
	"./TagSVG.vue": "c2ed",
	"./TermometerSVG.vue": "f195",
	"./TutorIASVG.vue": "88a95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d508";